<template>
    <div>
        <hr />
        <div class="field-container">
            <h2>Secondary Attack</h2>
            <div class="field quarter">
                <label for="" class="label">Attack Bonus Type</label>
                <div class="select">
                    <select name="" id="" :value="attack.secondary.bonusSource" @change="updateSecondaryAttackBonusSource">
                        <option value="weapon">Weapon</option>
                        <option value="implement">Implement</option>
                        <option value="statandbonus">Stat + Static Bonus</option>
                        <option value="static">Static Bonus</option>
                    </select>
                </div>
            </div>
            <div class="field quarter" v-if="attack.secondary.bonusSource != 'static'">
                <label for="" class="label">Attack Stat</label>
                <div class="select">
                    <select name="" id="" :value="attack.secondary.stat" @change="updateSecondaryStat">
                        <option value="Strength">Strength</option>
                        <option value="Dexterity">Dexterity</option>
                        <option value="Constitution">Constitution</option>
                        <option value="Intelligence">Intelligence</option>
                        <option value="Wisdom">Wisdom</option>
                        <option value="Charisma">Charisma</option>
                    </select>
                </div>
            </div>
            <div class="field quarter" v-if="isWeaponOrImplement">
                <label for="" class="label">Weapon/Implement #</label>
                <input type="text" class="input" :value="attack.secondary.weaponNumber" @input="updateSecondaryWeaponNumber">
            </div>
            <div class="field quarter">
                <label for="" class="label">Crit on</label>
                <input type="number" class="input" :value="attack.secondary.critRange" @input="updateSecondaryCritRange">
            </div>
        </div>
        <div class="field-container">
            <div class="field">
                <label for="" class="label">Target</label>
                <input type="text" class="input" :value="attack.secondary.target" @input="updateSecondaryTarget">
            </div>
            <div class="field quarter">
                <label for="" class="label">Defense</label>
                <div class="select">
                    <select name="" id="" :value="attack.secondary.defense" @change="updateSecondaryDefense">
                        <option value="AC">AC</option>
                        <option value="Fort">Fort</option>
                        <option value="Ref">Ref</option>
                        <option value="Will">Will</option>
                    </select>
                </div>
            </div>
            <div class="field quarter">
                <label for="" class="label">Static Attack Bonus</label>
                <input type="text" class="input" :value="attack.secondary.staticBonus" @input="updateSecondaryStaticBonus">
            </div>
        </div>
        <div class="field-container">
            <div class="field quarter">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="damage.secondary.hasDamage" @change="updateSecondaryHasDamage">
                    Has Damage?
                </label>
            </div>
            <div class="field quarter" v-if="damage.secondary.hasDamage">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="damage.secondary.addStatMod" @change="updateSecondaryAddStatMod">
                    Add Stat Mod?
                </label>
            </div>
            <div class="field quarter" v-if="damage.secondary.hasDamage">
                <label for="" class="checkbox">
                    <input type="checkbox" :checked="damage.secondary.isBrutal" @change="updateSecondaryIsBrutal">
                    Reroll Less than X (Brutal)?
                </label>
            </div>
        </div>
        <div class="field-container" v-if="damage.secondary.hasDamage">
            <div class="field quarter">
                <label for="" class="label">Dice/[W] Quantity</label>
                <input type="text" class="input" :value="damage.secondary.diceQuantity" @input="updateSecondaryDiceQuantity">
            </div>
            <div class="field quarter" v-if="attack.secondary.bonusSource != 'weapon'">
                <label for="" class="label">Dice Sides</label>
                <input type="text" class="input" :value="damage.secondary.diceSides" @input="updateSecondaryDiceSides">
            </div>
            <div class="field quarter">
                <label for="" class="label">Static Damage Bonus</label>
                <input type="text" class="input" :value="damage.secondary.staticBonus" @input="updateSecondaryStaticDamageBonus">
            </div>
            <div class="field quarter">
                <label for="" class="label">Damage Type</label>
                <input type="text" class="input" :value="damage.secondary.type" @input="updateSecondaryType">
            </div>
            <div class="field quarter" v-if="damage.secondary.isBrutal">
                <label for="" class="label">Brutal Value</label>
                <input type="text" class="input" :value="damage.secondary.brutalValue" @input="updateSecondaryBrutalValue">
            </div>
        </div>
        <div class="field-container">
            <div class="field full">
                <label for="" class="label">Hit Effect</label>
                <textarea name="" id="" cols="30" rows="3" class="textarea" :value="attack.secondary.hitEffect" @input="updateSecondaryHitEffect"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {

    },
    components: {

    },
    data: function() {
        return {

        };
    },
    computed: {
        ...mapState({
            attack: state => state.attack,
            damage: state => state.damage,
        }),
        isWeaponOrImplement() {
            return this.attack.secondary.bonusSource == 'weapon' || this.attack.secondary.bonusSource == 'implement';
        },
    },
    methods: {
        // attack
        updateSecondaryAttackBonusSource(e) {
            this.$store.commit('attack/setSecondaryBonusSource', e.target.value);
        },
        updateSecondaryStat(e) {
            this.$store.commit('attack/setSecondaryStat', e.target.value);
        },
        updateSecondaryWeaponNumber(e) {
            this.$store.commit('attack/setSecondaryWeaponNumber', e.target.value);
        },
        updateSecondaryStaticBonus(e) {
            this.$store.commit('attack/setSecondaryStaticBonus', e.target.value);
        },
        updateSecondaryTarget(e) {
            this.$store.commit('attack/setSecondaryTarget', e.target.value);
        },
        updateSecondaryDefense(e) {
            this.$store.commit('attack/setSecondaryDefense', e.target.value);
        },
        updateSecondaryHitEffect(e) {
            this.$store.commit('attack/setSecondaryHitEffect', e.target.value);
        },
        updateSecondaryCritRange(e) {
            this.$store.commit('attack/setSecondaryCritRange', e.target.value);
        },
        // damage
        updateSecondaryDiceQuantity(e) {
            this.$store.commit('damage/setSecondaryDiceQuantity', e.target.value);
        },
        updateSecondaryDiceSides(e) {
            this.$store.commit('damage/setSecondaryDiceSides', e.target.value);
        },
        updateSecondaryStaticDamageBonus(e) {
            this.$store.commit('damage/setSecondaryStaticBonus', e.target.value);
        },
        updateSecondaryAddStatMod(e) {
            this.$store.commit('damage/setSecondaryAddStatMod', e.target.checked);
        },
        updateSecondaryHasDamage(e) {
            this.$store.commit('damage/setSecondaryHasDamage', e.target.checked);
        },
        updateSecondaryType(e) {
            this.$store.commit('damage/setSecondaryType', e.target.value);
        },
        updateSecondaryIsBrutal(e) {
            this.$store.commit('damage/setSecondaryIsBrutal', e.target.checked);
        },
        updateSecondaryBrutalValue(e) {
            this.$store.commit('damage/setSecondaryBrutalValue', e.target.value);
        },
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
